import type { TypedUseSelectorHook } from 'react-redux'
import type { AppDispatch, RootState } from 'APP/Store/CreateStore'
/* eslint-disable-next-line no-restricted-imports */
import { useDispatch as useDispatchUntyped, useSelector as useSelectorUntyped } from 'react-redux'

export const useDispatch = useDispatchUntyped<AppDispatch>
export const useSelector: TypedUseSelectorHook<Readonly<RootState>> = useSelectorUntyped
